import React, {Component} from 'react'
import propTypes from 'prop-types'
import {connect} from 'react-redux'
import {get, isEmpty, isNil} from 'lodash'
import {getCurrency} from 'helpers/quotes'
import {CurrencyDisplayFormat, getFinancialValue, getUnicodeCharacter} from 'helpers/financial'
import {getCurrencies} from 'selectors/data'
import {getCurrencyPrecision} from 'selectors/settings'

class FinancialString extends Component {
  getFinancialCurrency = (currencyId, currencies) => {
    return !isNil(currencyId) && !isNil(currencies)
        ? getCurrency(currencyId, currencies)
        : null
  }

  getShortDescription = (currency, homeCurrencyShortDesc) => {
    return isNil(currency)
        ? homeCurrencyShortDesc
        : get(currency, 'shortDesc', '')
  }

  getUnicodePattern = (currency, homeCurrencyUnicodePattern) => {
    return isNil(currency)
        ? homeCurrencyUnicodePattern
        : get(currency, 'unicodePattern', '')
  }

  getCurrencyDisplayFormat = (currencyDisplayFormat) => {
    return !isNil(currencyDisplayFormat)
        ? currencyDisplayFormat
        : CurrencyDisplayFormat.international
  }

  getLocalFormattedValue = (financialValue, unicodePattern) => {
    const currencySymbol = getUnicodeCharacter(unicodePattern)
    return currencySymbol + financialValue
  }

  getInternationalFormattedValue = (financialValue, shortDesc) => {
    return `${financialValue} ${shortDesc}`
  }

  getFormattedValue = (financialValue, format, unicodePattern, shortDesc) => {
    switch (format) {
      case CurrencyDisplayFormat.local:
        return isEmpty(unicodePattern)
          ? this.getInternationalFormattedValue(financialValue, shortDesc)
          : this.getLocalFormattedValue(financialValue, unicodePattern)

      case CurrencyDisplayFormat.international:
        return this.getInternationalFormattedValue(financialValue, shortDesc)
      default:
        return this.getInternationalFormattedValue(financialValue, shortDesc)
    }
  }

  render() {
    const {
      value, currencyId, currencies, precision, homeCurrencyUnicodePattern,
      homeCurrencyShortDesc, currencyDisplayFormat, inline,
    } = this.props

    const currency = this.getFinancialCurrency(currencyId, currencies)
    const unicodePattern = this.getUnicodePattern(currency, homeCurrencyUnicodePattern)
    const shortDesc = this.getShortDescription(currency, homeCurrencyShortDesc)
    const format = this.getCurrencyDisplayFormat(currencyDisplayFormat)
    const financialValue = getFinancialValue(value, precision)
    const formattedValue = this.getFormattedValue(financialValue, format, unicodePattern, shortDesc)

    return inline
        ? <span className="financialString">{formattedValue}</span>
        : <div className="financialString">{formattedValue}</div>
  }
}

FinancialString.propTypes = {
  value: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
  ]),
  currencyId: propTypes.number,
  inline: propTypes.bool,
  precision: propTypes.number,
  currencies: propTypes.array,
  homeCurrencyUnicodePattern: propTypes.string,
  homeCurrencyShortDesc: propTypes.string,
  currencyDisplayFormat: propTypes.number,
}

FinancialString.defaultProps = {
  precision: 2,
  currencies: [],
}

const mapStateToProps = (state, ownProps) => {
  return {
    homeCurrencyUnicodePattern: state.auth.user.currencyUnicodePattern,
    homeCurrencyShortDesc: state.auth.user.currencyShortDesc,
    currencyDisplayFormat: ownProps.currencyDisplayFormat || get(state, 'auth.user.settings.currencyDisplayFormat.id'),
    currencies: getCurrencies(state),
    precision: !isNil(ownProps.precision) ? ownProps.precision : getCurrencyPrecision(state),
  }
}

const FinancialStringContainer = connect(
  mapStateToProps
)(FinancialString)

export default FinancialStringContainer
